import Vue from "vue";
import Element from 'element-ui'
import {
    Message,
    MessageBox,
    Notification,
    Loading
} from "element-ui";
import App from "./App";
import router from "./router";
import RouterTab from "vue-router-tab";
import userDetail from '@/views/BaseSettings/component/orgStructureSettings/userDetail.vue'

import '@/styles/element-variables.scss'
import "vue-router-tab/dist/lib/vue-router-tab.css";
// import VueAMap from "vue-amap";
import "babel-polyfill";
// import './permission' // permission control
import AMapLoader from '@amap/amap-jsapi-loader';
import Amap from '@/utils/amap.js'
import '@/utils/element.js'
import "@/main.css";
import "@/styles/index.scss";
import store from './store'
import JsonExcel from "vue-json-excel"
import '@/assets/styles/index.scss' // global css
Vue.use(Amap)
Vue.use(Element)
// Vue.use(Message,{zIndex:3000})
Vue.config.productionTip = false; // 阻止启动生产消息
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$notify = Notification;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.component("downloadExcel",JsonExcel);
Vue.component("user-detail",userDetail);
const render = Element.Input.render;
Element.Input.props.clearable.default = true;

// Element.Input.render = function () {
// 	// textarea 不做限制
// 	if (this.$options.propsData.type === 'textarea') {
// 	    return render.apply(this, arguments)
// 	};
//     // this.$attrs.clearable.default = true
// 	// 设置组件默认原生属性（attr）
//     debugger
// 	this.$attrs.maxlength || (this.$attrs.maxlength = 100); // 如果没有单独设置maxlength，就使用默认的配置（50）
// 	return render.apply(this, arguments)
// }

Vue.use(RouterTab);
Vue.use(Loading.directive);

new Vue({
    el: "#app",
    store,
    router,
    components: { App },
    template: "<App/>"
});




// WEBPACK FOOTER //
// ./src/main.js